/*jshint -W083 */
/*jshint -W044 */
/**
 * Directive: lineGraph
 */
angular.module('acme.common.directive.lineGraph', [])
.directive('lineGraph', ['$timeout', '$log', function($timeout, $log) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/lineGraph/lineGraph.tpl.html',
      scope: {
        model: '=',
        timeScale: '=',
        minDate: '=',
        maxDate: '=',
        totalRevenue: '=',
        totalTickets: '='
      },
      
      link: function($scope, $element, $attrs) {

        $scope.lineGraphLink = {
          x: 0,
          y: 0,
          svg: false,
          svgRoot: false,
          line: {},
          width: 0,
          height: 0,
          xAxis: {},
          yAxis: {},
          y2Axis: {},
          margin: { top: 20, right: 50, bottom: 30, left: 50 },
          parseDate: d3.time.format("%Y-%-m-%d").parse,
          aspect: 0,
          targetWidth: 0,
          targetHeight: 0,
          parentHeight: 450,
          parentWidth: 750,
          resizeTimer: {},
          scaleWatcher: false,
          modelWatcher: false,
          maxDate: false,
          minDate: false,

          init: function() {
            this.aspect = this.parentHeight / this.parentWidth;
            this.targetWidth = this.parentHeight / this.aspect;
            this.targetHeight = this.parentHeight;
            this.width = this.targetWidth - this.margin.left - this.margin.right;
            this.height = this.targetHeight - this.margin.top - this.margin.bottom;


            this.x = d3.time.scale()
              .range([0, this.width])
              .clamp(true);

            this.y = d3.scale.linear()
              .range([this.height, 0]);

            this.y2 = d3.scale.linear()
              .range([this.height, 0]);

            this.xAxis = d3.svg.axis()
              .scale(this.x)
              .orient("bottom");

            this.yAxis = d3.svg.axis()
              .scale(this.y)
              .orient("left");

            this.y2Axis = d3.svg.axis()
              .scale(this.y2)
              .orient("right");

            this.line = d3.svg.line()
              .x(function(d) { return $scope.lineGraphLink.x(d.date); })
              .y(function(d) { return $scope.lineGraphLink.y(d.revenue); });

            if (!this.svg) {
              this.svg = d3.select("#line-graph-vis").append('svg')
                .attr("id", "line-graph-svg")
                .append("g")
                .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
              this.svgRoot = d3.select('#line-graph-svg');
            }

            this.svgRoot
              .attr("width", this.width + this.margin.left + this.margin.right)
              .attr("height", this.height + this.margin.top + this.margin.bottom);


            $scope.lineGraph.link = $scope.lineGraphLink;

            if (this.modelWatcher) {
              this.modelWatcher();
            }

            this.modelWatcher = $scope.$watch('model', function(n, o) {

              if ($scope.model.length > 0) {
                $scope.lineGraph.model = $scope.model;
                $scope.lineGraph.init();
                $scope.lineGraph.plot();
              }

            });

            if (this.scaleWatcher) {
              this.scaleWatcher();
            }

            this.scaleWatcher = $scope.$watch('timeScale', function(n, o) {
              if ($scope.model.length > 0) {
                $scope.lineGraph.plot();
              }
            });

            if (this.minDate) {
              this.minDate();
            }

            this.minDate = $scope.$watch('minDate', function(n, o) {
              if ($scope.model.length > 0) {
                $scope.lineGraphLink.x.domain([$scope.minDate, $scope.maxDate]);
                $scope.lineGraph.plot();
              }
            });

            if (this.maxDate) {
              this.maxDate();
            }

            this.maxDate = $scope.$watch('maxDate', function(n, o) {
              if ($scope.model.length > 0) {
                $scope.lineGraphLink.x.domain([$scope.minDate, $scope.maxDate]);
                $scope.lineGraph.plot();
              }
            });


            $(window).unbind('resize');
            $(window).bind('resize', function() {
              if ($scope.lineGraphLink.resizeTimer) {
                $timeout.cancel($scope.lineGraphLink.resizeTimer);
              }
              $scope.lineGraphLink.resizeTimer = $timeout(function() {
                var p =  $('#line-graph-svg').parent();
                $scope.lineGraphLink.parentWidth = p.width();
                $scope.lineGraphLink.init();
                $scope.lineGraph.plot();
                p.addClass('show');
              }, 100);
            });
          }

        };

        $scope.lineGraphLink.init();

      },

      controller: ['$scope', function($scope) {

        $scope.lineGraph = {

          gx: false,
          gy: false,
          gy2: false,
          tooltip: false,
          link: {},
          model: {},
          selected: {},
          cachedSelection: {},
          lines: [],
          trimmed: [],
          bisectDate: d3.bisector(function(d) { return d.date; }).left,
          tooltipTimer: false,
          moveTimer: false,
          lastPointIndex: -1,
          currentPointIndex: 0,
          currentPointDate: false,
          currentPointRevenues: [],
          lockedPoints: [],
          lockedPointIndicies: [],
          lockedPointData: {},
          svgPos: 0,

          init: function() {
            this.initSelected();
            if (!this.initted) {
              $scope.$watchCollection('lineGraph.selected', this.onSelectedUpdate);
              $(window).trigger('resize');
            }
            this.initted = true;
          },

          initSelected: function() {
            var i, ii;
            for(i=0,ii=this.model.length;i<ii;i++) {
              if (!this.cachedSelection.hasOwnProperty(this.model[i].eventId)) {
                this.selected[this.model[i].eventId] = true;
                this.cachedSelection[this.model[i].eventId] = true;
              }else{
                this.selected[this.model[i].eventId] = this.cachedSelection[this.model[i].eventId];
              }
            }
          },

          updateGraph: function() {
            $timeout(function() {
              $scope.lineGraph.plot();
            }, 0);
          },

          updateDots: function(x) {
            var i, ii,
                d,
                d0,
                d1,
                tip = '',
                left = 0,
                currentDate = '',
                totalRevenue = 0,
                totalTickets = 0,
                data = this.trimmed,
                formatNumber = d3.format(",d"),
                formatValue = d3.format(",.2f"),
                formatCurrency = function(d) { return "$" + formatValue(d); },
                formatNumeric = function(d) { return formatNumber(d); },
                formatDate = d3.time.format("%m/%-d/%y");

            this.currentPointRevenues = [];

            for (i=0,ii=data.length;i<ii;i++) {

              this.currentPointIndex = this.bisectDate(data[i], x, 1);

              d0 = data[i][this.currentPointIndex - 1];
              d1 = data[i][this.currentPointIndex];

              if (d1 && ((x - d0.date) >= (d1.date - x))) {
                d = d1;
              }else{
                d = d0;
                this.currentPointIndex -= 1;
              }

              if (d.hasOwnProperty('date')) {
                left = (this.link.x(d.date) > this.svgPos.right) ? this.svgPos.right - 300 : this.link.x(d.date) + this.svgPos.left + this.link.margin.left;
              }
              if (this.lockedPointData[data[i][this.currentPointIndex].eventId]) {
                d = this.lockedPointData[data[i][this.currentPointIndex].eventId];
              }


              this.currentPointDate =  d.date;
              this.currentPointRevenues.push(d.revenue);

              d3.select('#circles-'+i)
                .transition()
                .duration(200)
                .ease('out')
                .attr("cx", this.link.x(this.currentPointDate))
                .attr("cy", this.link.y(this.currentPointRevenues[i]));

              if (this.selected[d.eventId]) {
                tip += "<p class=\"event\"><span class=\"c" + i + "\">" + d.eventName + "</span> " + formatCurrency(d.revenue) + "<br /><span>" + d.eventName + "</span> Sales: "+ formatNumeric(d.quantity) +"</p>";
                totalRevenue += d.revenue;
                totalTickets += d.quantity;
              }
              currentDate = formatDate(d.date);
            }

            tip = "<h5>Summary " + currentDate + "</h5>" + tip;
            tip += "<p class=\"totals\">";
            tip += "Total revenue: <b>" + formatCurrency(totalRevenue) + "</b><br />";
            tip += "Total ticket sales: <b>" + formatNumeric(totalTickets) + "</b>";
            tip += "</p>";
            $scope.lineGraph.tooltip
              .style("opacity", 1)
              .style("top", ($scope.lineGraph.svgPos.top + 10) + "px")
              .style("left", (left + 30) + "px")
              .html(tip);

            this.lastPointIndex = this.currentPointIndex;

          },

          plot: function() {

            var i, ii,
                j, jj,
                opacity = 0,
                extent = [],
                trimmed = [],
                truncated = [],
                totalRevenue = 0,
                totalTickets = 0,
                msDay = 86400000;

            this.svgPos = $('#line-graph-svg').offset();

            for (i=0,ii=this.model.length;i<ii;i++) {

              trimmed.push([]);
              truncated.push([]);

              for (j = 0, jj = this.model[i].eventRevenueMetrics.length; j < jj; j++) {
                this.model[i].eventRevenueMetrics[j].date = this.link.parseDate(this.model[i].eventRevenueMetrics[j].formattedEventDate);
                this.model[i].eventRevenueMetrics[j].revenue = +this.model[i].eventRevenueMetrics[j].revenue;
                this.model[i].eventRevenueMetrics[j].eventName = this.model[i].eventName;
                this.model[i].eventRevenueMetrics[j].eventId = this.model[i].eventId;
                if (this.model[i].eventRevenueMetrics[j].date.getTime() >= $scope.minDate.getTime() &&
                    this.model[i].eventRevenueMetrics[j].date.getTime() <= $scope.maxDate.getTime() + msDay) {
                  trimmed[i].push(this.model[i].eventRevenueMetrics[j]);
                  if (this.selected[this.model[i].eventId]) {
                    totalRevenue += this.model[i].eventRevenueMetrics[j].revenue;
                    totalTickets += this.model[i].eventRevenueMetrics[j].quantity;
                  }
                }else{
                  truncated[i].push(this.model[i].eventRevenueMetrics[j]);
                }
              }

              this.trimmed = trimmed;
              extent = extent.concat(this.trimmed[i].slice(0));

            }

            this.link.svgRoot.on("mousemove", null);
            this.link.svgRoot
              .on("mouseover", function() {
                if ($scope.lineGraph.tooltipTimer) {
                  $timeout.cancel($scope.lineGraph.tooltipTimer);
                }
                $scope.lineGraph.tooltip.style("display", null);
              })
              .on("mouseout", function() {
                if ($scope.lineGraph.tooltipTimer) {
                  $timeout.cancel($scope.lineGraph.tooltipTimer);
                }
                $scope.lineGraph.tooltipTimer = $timeout(function() {
                  $scope.lineGraph.tooltip.style("display", "none");
                }, 10);
              })
              .on("mousemove", function() {

                var xMouse = d3.mouse(this)[0],
                    x = $scope.lineGraph.link.x.invert(xMouse);

                if ($scope.lineGraph.moveTimer) {
                  $timeout.cancel($scope.lineGraph.moveTimer);
                }
                $scope.lineGraph.moveTimer = $timeout(function() {
                  $scope.lineGraph.updateDots(x);
                }, 10);

              });

            this.link.x.domain([$scope.minDate, $scope.maxDate]);

            this.link.y.domain([d3.min(extent, function(d) { return d.revenue; }), d3.max(extent, function (d) {
              return d.revenue;
            })]);
            this.link.y2.domain([d3.min(extent, function(d) { return d.quantity; }), d3.max(extent, function (d) {
              return d.quantity;
            })]);

            if (this.gx) {
              d3.selectAll('#x1-axis').call(this.link.xAxis);
            }else{

              this.gx = this.link.svg.append("g")
                .attr("id", "x1-axis")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + this.link.height + ")")
                .call(this.link.xAxis);
            }

            if (this.gy) {
              d3.selectAll('#y1-axis').call(this.link.yAxis);
            }else {
              this.gy = this.link.svg.append("g")
                .attr("id", "y1-axis")
                .attr("class", "y axis")
                .call(this.link.yAxis);

              this.gy
                .append("rect")
                .attr("height", "20")
                .attr("width", "50")
                .attr("fill", "#fff")
                .attr("transform", "rotate(-90)")
                .attr("y", -10)
                .attr("x", -(this.link.height / 2) - 45);

              this.gy
                .append("text")
                .attr("transform", "rotate(-90)")
                .attr("class", "axis-label")
                .attr("y", -6)
                .attr("dy", ".71em")
                .attr("x", -(this.link.height / 2))
                .style("text-anchor", "end")
                .text("Revenue");
            }

            if (this.gy2) {
              d3.selectAll('#y2-axis')
                .attr("transform", "translate(" + this.link.width + ", 0)")
                .call(this.link.y2Axis);
            }else {
              this.gy2 = this.link.svg.append("g")
                .attr("id", "y2-axis")
                .attr("class", "y2 axis")
                .attr("transform", "translate(" + this.link.width + ", 0)")
                .call(this.link.y2Axis);

              this.gy2
                .append("rect")
                .attr("height", "20")
                .attr("width", "40")
                .attr("fill", "#fff")
                .attr("transform", "rotate(-90)")
                .attr("y", 0)
                .attr("x", -(this.link.height / 2) - 35);

              this.gy2
                .append("text")
                .attr("transform", "rotate(90)")
                .attr("y", -2)
                .attr("dy", ".5em")
                .attr("x", (this.link.height / 2))
                .style("text-anchor", "start")
                .text("Tickets");
            }

            if (!this.tooltip) {
              this.tooltip = d3.select("body").append("div")
                .attr("class", "line-graph-tooltip")
                .style("opacity", 0);


            }

            for (i=0,ii=this.model.length;i<ii;i++) {

              opacity = (this.selected[this.model[i].eventId]) ? 1 : 0;

              if (!this.lines[i]) {
                this.lines[i] = {};
              }

              if (!this.lines[i].path) {
                this.lines[i].path = this.link.svg.append('path');
              }

              this.lines[i].path
                .data([this.trimmed[i]])
                .attr("id", "line-"+i)
                .attr("class", "line c" + i)
                .attr("d", this.link.line)
                .attr("opacity", opacity);


              d3.select('#circles-'+i)
                .selectAll('circle')
                .remove();


              if (!this.lines[i].dots) {
                this.lines[i].dots = this.link.svg.append('circle')
                  .datum({ index: i, data: this.trimmed })
                  .attr("id", "circles-"+i)
                  .attr("class", "circle c" + i)
                  .attr("r", 4)
                  .on("click", function(d) {
                    var currentIndex = $scope.lineGraph.currentPointIndex,
                        currentData = d.data[d.index][currentIndex];

                    if (!$scope.lineGraph.lockedPointData[currentData.eventId]) {
                      d3.select(this).attr("class", "circle locked c" + d.index);
                      $scope.lineGraph.lockedPointData[currentData.eventId] = currentData;
                    }else{
                      d3.select(this).attr("class", "circle c" + d.index);
                      $scope.lineGraph.lockedPointData[currentData.eventId] = null;
                    }

                  });
              }

              if (this.trimmed[i][this.currentPointIndex] && this.lockedPointData[this.trimmed[i][this.currentPointIndex].eventId]) {
                this.lines[i].dots
                  .attr("cx", this.link.x(this.lockedPointData[this.trimmed[i][this.currentPointIndex].eventId].date))
                  .attr("cy", this.link.y(this.lockedPointData[this.trimmed[i][this.currentPointIndex].eventId].revenue));
              }else{
                this.lines[i].dots
                  .attr("cx", this.link.x(this.trimmed[i][parseInt(this.trimmed[i].length / 2, 10)].date))
                  .attr("cy", this.link.y(this.trimmed[i][parseInt(this.trimmed[i].length / 2, 10)].revenue));
              }

              this.lines[i].dots
                .attr("opacity", opacity);

            }

            $scope.totalRevenue = totalRevenue;
            $scope.totalTickets = totalTickets;

          },

          onSelectedUpdate: function(n) {
            angular.copy(n, $scope.lineGraph.cachedSelection);
            $scope.lineGraph.updateGraph();
          }


        };

      }]

    };

}]);